import React from "react";
import SafeIcon from "../../../common/SafeIcon";
import { FiCalendar, FiRotateCcw, FiSearch } from "react-icons/fi";

export default function ClientTransactionFilters({
  search,
  startDate,
  endDate,
  accountId,
  accounts,
  onChange,
  onReset,
}) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:p-5">
      <div className="grid gap-4 lg:grid-cols-[minmax(220px,1.5fr)_repeat(2,minmax(145px,1fr))_minmax(190px,1fr)_auto]">
        <label className="block">
          <span className="mb-2 block text-xs font-semibold text-slate-600">
            Search transactions
          </span>
          <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2.5 focus-within:border-violet-400 focus-within:ring-4 focus-within:ring-violet-500/10">
            <SafeIcon icon={FiSearch} className="shrink-0 text-slate-400" />
            <input
              value={search}
              onChange={(event) => onChange("search", event.target.value)}
              placeholder="Description, reference, or account"
              className="min-w-0 flex-1 bg-transparent text-sm text-slate-800 outline-none placeholder:text-slate-400"
            />
          </span>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-semibold text-slate-600">
            From
          </span>
          <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2.5">
            <SafeIcon icon={FiCalendar} className="shrink-0 text-slate-400" />
            <input
              type="date"
              value={startDate}
              max={endDate || undefined}
              onChange={(event) => onChange("startDate", event.target.value)}
              className="min-w-0 w-full bg-transparent text-sm text-slate-700 outline-none"
            />
          </span>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-semibold text-slate-600">
            To
          </span>
          <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2.5">
            <SafeIcon icon={FiCalendar} className="shrink-0 text-slate-400" />
            <input
              type="date"
              value={endDate}
              min={startDate || undefined}
              onChange={(event) => onChange("endDate", event.target.value)}
              className="min-w-0 w-full bg-transparent text-sm text-slate-700 outline-none"
            />
          </span>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-semibold text-slate-600">
            Account
          </span>
          <select
            value={accountId}
            onChange={(event) => onChange("accountId", event.target.value)}
            className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700 outline-none focus:border-violet-400 focus:ring-4 focus:ring-violet-500/10"
          >
            <option value="all">All accounts</option>
            {accounts.map((account) => (
              <option key={account.id} value={account.id}>
                {account.code ? `${account.code} · ` : ""}
                {account.name}
              </option>
            ))}
          </select>
        </label>

        <div className="flex items-end">
          <button
            type="button"
            onClick={onReset}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 hover:text-slate-900 lg:w-auto"
          >
            <SafeIcon icon={FiRotateCcw} />
            Reset
          </button>
        </div>
      </div>
    </section>
  );
}